import { AxiosResponse } from "axios";

interface ApiResponse<T> {
  data: T;
  message?: string;
  status?: number;
}

export interface HotelInfo {
  hotelid: string;
  name: string | null;
  phone: string | null;
  email: string | null;
  website: string | null;
  timezone: string | null;
  logo: string | null; // S3 key or signed URL depending on backend enhancement
  mapfile: string | null; // S3 key or signed URL depending on backend enhancement
  addressid: string | null;
  _media?: {
    logo?: {
      key: string;
      signedUrl?: string;
      expiresAt?: string | Date;
    };
    mapfile?: {
      key: string;
      signedUrl?: string;
      expiresAt?: string | Date;
    };
  };
}

export type CallApiFn = <T = unknown>(config: {
  method: "GET" | "POST" | "PUT" | "DELETE";
  url: string;
  params?: Record<string, unknown>;
  data?: unknown;
}) => Promise<AxiosResponse<T>>;

export const makeHotelApi = (callApi: CallApiFn) => {
  const getHotelInfo = async (): Promise<HotelInfo> => {
    const response = await callApi<ApiResponse<HotelInfo>>({
      method: "GET",
      url: "/management/hotel",
    });
    return response.data.data;
  };

  const updateHotelInfo = async (
    updates: Partial<
      Pick<
        HotelInfo,
        "name" | "phone" | "email" | "website" | "timezone" | "logo" | "mapfile"
      >
    >
  ): Promise<HotelInfo> => {
    const response = await callApi<ApiResponse<HotelInfo>>({
      method: "PUT",
      url: "/management/hotel",
      data: updates,
    });
    return response.data.data;
  };

  return { getHotelInfo, updateHotelInfo };
};
